import { useApp } from '../../lib/app';

const LABEL: Record<string, string> = {
  synced: 'Synced',
  pending: 'Pending',
  offline: 'Offline',
  error: 'Sync error',
  paused: 'Signed out',
};

/** Always tells the truth about the sync state (plan ground rule #5). */
export function SyncBadge() {
  const { syncStatus: s, mode, sync } = useApp();
  if (mode === 'local') return <span className="sync-badge sync-offline" title="No account — data stays on this device">Local</span>;
  const text =
    s.state === 'pending' ? `Pending ${s.pending}` : s.state === 'error' ? 'Error, retrying' : LABEL[s.state] ?? s.state;
  const rej = s.rejected ? ` · ${s.rejected} rejected` : '';
  return (
    <button className={`sync-badge sync-${s.state}`} style={{ border: 'none', cursor: 'pointer' }} title={s.lastError ?? 'Tap to sync now'} onClick={() => void sync()}>
      {text}
      {rej}
    </button>
  );
}
